import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lc-dashboard',
  templateUrl: './lc-dashboard.component.html',
  styleUrls: ['./lc-dashboard.component.scss']
})
export class LcDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
